module.exports = __webpack_public_path__ + "media/images/illustration/undraw_Building_re_xfcm-ea93746fa272beb05754dc9ef3521fcd.svg";